/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { OptionsObject, SnackbarKey, SnackbarMessage } from 'notistack';

import { StoreAction } from '../../types/helpers/StoreAction';

export enum NotifierActions {
  ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR',
  CLOSE_SNACKBAR = 'CLOSE_SNACKBAR',
  REMOVE_SNACKBAR = 'REMOVE_SNACKBAR',
}

export type Notification = {
  message: SnackbarMessage;
  options?: OptionsObject;
  key?: SnackbarKey;
  dismissed?: boolean;
};

export type NotifierState = {
  notifications: Notification[];
};

export type NotifierActionTypes = StoreAction<NotifierActions>;
